import { useNavigate, useLocation } from 'react-router-dom';
import { TALENT } from '../../../data/define';
import FullHeightContainer from '../../../component/common/FullHeightContainer';
import TopHeaderWithPrev from '../../../component/common/TopHeaderWithPrev';
import Relationship from '../../../component/report/commentary/Relationship';
import Nature from '../../../component/report/commentary/Nature';
import Language from '../../../component/report/commentary/Language';
import Space from '../../../component/report/commentary/Space';
import Music from '../../../component/report/commentary/Music';
import Math from '../../../component/report/commentary/Math';
import Reflection from '../../../component/report/commentary/Reflection';
import Physical from '../../../component/report/commentary/Physical';
import { useTranslation } from '../../../hook/useTranslation';

function ReportDetailCommentary() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { intelligence } = (location.state as any) || {};

  return (
    <FullHeightContainer>
      <TopHeaderWithPrev
        title={t(`history.video.intelligence_title`, { label: t(`talent.${intelligence?.key}`) })}
        onClickPrev={() => navigate(-1)}
      />
      <div className="pageInner" style={{ padding: 0 }}>
        {intelligence?.id === TALENT.RELATIONSHIP.id && <Relationship />}
        {intelligence?.id === TALENT.NATURE.id && <Nature />}
        {intelligence?.id === TALENT.LANGUAGE.id && <Language />}
        {intelligence?.id === TALENT.SPACE.id && <Space />}
        {intelligence?.id === TALENT.MUSIC.id && <Music />}
        {intelligence?.id === TALENT.MATH.id && <Math />}
        {intelligence?.id === TALENT.REFLECTION.id && <Reflection />}
        {intelligence?.id === TALENT.PHYSICAL.id && <Physical />}
      </div>
    </FullHeightContainer>
  );
}

export default ReportDetailCommentary;
